import React from "react";
import {Button, Modal} from "semantic-ui-react";
import {PaymentDetails} from "./PaymentDetailsContainer";
import PaperCheckModal from "./paperCheckModal";

const PaperCheckConfirmationModal = ({onConfirm, loading, strings}) => {
    const {paperCheckConfirmationVisibility, hidePaperCheckConfirmartion} = PaymentDetails.useContainer();

    return (
        <PaperCheckModal strings={strings}
                         onClose={hidePaperCheckConfirmartion}
                         open={paperCheckConfirmationVisibility}
                         msgText={strings.itLooksLikeYouDidntAdd}
                         msgType="warning">
            <Modal.Actions>
                <Button primary basic onClick={hidePaperCheckConfirmartion}>{strings.goBack}</Button>
                <Button primary onClick={()=>{onConfirm(); hidePaperCheckConfirmartion()}} disabled={loading}>{strings.confirmAndSubmit}</Button>
            </Modal.Actions>
        </PaperCheckModal>
    )
}

export default PaperCheckConfirmationModal;
